module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('h1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.warning),
      expression: "warning"
    }],
    staticClass: "ui red header"
  }, [_vm._v("PROTOTYPE: Only tested in Chrome, No real data, \"Loading Delay\" is fake, This is a WORK IN PROGRESS")]), _vm._v(" "), _c('section', {
    staticClass: "ui top attached clearing segment"
  }, [_c('top-nav')], 1), _vm._v(" "), _c('section', {
    staticClass: "ui attached content segment"
  }, [_c('topic-explorer'), _vm._v(" "), _c('router-view', {
    attrs: {
      "wiki": _vm.wiki
    },
    on: {
      "wiki": _vm.wikiSelected
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "ui attached language segment"
  }, [_c('site-language')], 1), _vm._v(" "), _c('section', {
    staticClass: "ui attached footer segment"
  }, [_c('bottom-footer')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-6d54ba6d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 392
// module chunks = 1